import AxiosJob from '@/services/api/job/axios_job'

export default {
  createPoolStatus: (data) => {
    return AxiosJob.post('pool-status', data)
  },

  updatePoolStatus: (poolStatusId, data) => {
    return AxiosJob.put(`pool-status/${poolStatusId}`, data)
  },

  getPoolStatusesFromStatus: (statusId) => {
    return AxiosJob.get(`pool-status/status/${statusId}`)
  },

  getPoolStatusesFromPool: (poolId) => {
    return AxiosJob.get(`pool-status/pool/${poolId}`)
  },

  getPoolStatus: (poolStatusId) => {
    return AxiosJob.get(`pool-status/${poolStatusId}`)
  },

  deletePoolStatus: (poolStatusId) => {
    return AxiosJob.delete(`pool-status/${poolStatusId}`)
  }
}
